export const translations = {
  codigoSap: {
    pt: 'Código JDE',
    en: 'JDE Code',
    es: 'Código JDE',
    de: 'JDE-Code',
  },
  codigo: {
    pt: 'Código',
    en: 'Code',
    es: 'Código',
    de: 'Code',
  },
  descricao: {
    pt: 'Adicione abaixo os códigos JDE referente a esse cliente.',
    en: 'Add the JDE codes below for this client.',
    es: 'Fügen Sie die JDE-Codes für diesen Kunden unten ein.',
    de: 'Fügen Sie unten die JDE-Codes für diesen Kunden hinzu.',
  },
  adicionar: {
    pt: 'Adicionar',
    en: 'Add',
    es: 'Agregar',
    de: 'Hinzufügen',
  },
};
